__turbopack_context__.v({
  "chevron": "Disclosure-module__RiGTBG__chevron",
  "disclosure": "Disclosure-module__RiGTBG__disclosure",
  "group": "Disclosure-module__RiGTBG__group",
  "heading": "Disclosure-module__RiGTBG__heading",
  "leadingElement": "Disclosure-module__RiGTBG__leadingElement",
  "lg": "Disclosure-module__RiGTBG__lg",
  "md": "Disclosure-module__RiGTBG__md",
  "noBorder": "Disclosure-module__RiGTBG__noBorder",
  "panel": "Disclosure-module__RiGTBG__panel",
  "sm": "Disclosure-module__RiGTBG__sm",
  "titleText": "Disclosure-module__RiGTBG__titleText",
  "trigger": "Disclosure-module__RiGTBG__trigger",
  "xl": "Disclosure-module__RiGTBG__xl",
});
